export const APP_NAME = process.env.REACT_APP_APP_NAME || "DocLove";
export const APP_URL = process.env.REACT_APP_APP_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const APP_DOMAIN = (APP_URL || "").replace(/^https?:\/\//, "").replace(/\/$/, "");

export const FEATURES = {
  whatsapp: true,   // enabled at OVH deployment (FEATURE_WHATSAPP_IMPORT)
  magicLink: false,  // enabled once a Resend key is provided
};

export const PLAN_LABELS = {
  dmd_monthly: { name: "Mensuel", price: "9,99€", period: "/mois" },
  dmd_yearly: { name: "Annuel", price: "49€", period: "/an", badge: "3 mois offerts" },
};
